import { Components, Theme } from "@mui/material/styles";
import { buttonRootStyles, containedMap, ghostMap, outlinedMap } from "../button/styles";

export const MuiIconButton: Components<Theme>["MuiIconButton"] = {
    defaultProps: {
        color: "gray",
        variant: "contained",
    },
    styleOverrides: {
        root: buttonRootStyles,

        sizeSmall: {
            width: "40px",
            height: "40px",
        },
        sizeMedium: {
            width: "48px",
            height: "48px",
        },
        sizeLarge: {
            width: "56px",
            height: "56px",
        },

        sizeExtraSmall: {
            width: "32px",
            height: "32px",
        },
    },

    variants: [
        {
            props: { variant: "contained", color: "gray" },
            style: containedMap.gray,
        },
        {
            props: { variant: "contained", color: "green" },
            style: containedMap.green,
        },
        {
            props: { variant: "outlined", color: "gray" },
            style: { ...outlinedMap.gray, border: "1px solid currentColor" },
        },
        {
            props: { variant: "outlined", color: "green" },
            style: { ...outlinedMap.green, border: "1px solid currentColor" },
        },
        {
            props: { variant: "ghost", color: "gray" },
            style: ghostMap.gray,
        },
        {
            props: { variant: "ghost", color: "green" },
            style: ghostMap.green,
        },
        {
            props: { variant: "round" },
            style: {
                ...ghostMap.gray,
                backgroundColor: "white",
                borderRadius: "100%",
                outline: "1px solid var(--mui-palette-gray-200)",
                "&:hover": {
                    backgroundColor: "var(--mui-palette-gray-50)",
                },
            },
        },
    ],
};
